import React from 'react'
import RiseLoader from "react-spinners/RiseLoader";
import { blueColor } from '../constants/theme';

function Loading() {
  return (
    <div className='main-container'>
        <RiseLoader color={blueColor} size={8} />
    </div>
  )
}

export default Loading